import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  currentFiltersSelector,
  SBAT_GROUP_FILTERS,
  setFilterValue,
} from 'features/classCreation';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';
import Select from 'components/Select';

function AcademyTopicFilter({ sbatGroups }) {
  const dispatch = useDispatch();
  const { academyTopics } = useSelector(currentFiltersSelector);
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  const academyTopicOptions = useMemo(
    () =>
      sbatGroups.map((sbatGroup) => ({
        value: sbatGroup.academy_topic.id,
        label: sbatGroup.academy_topic.title,
      })),
    [sbatGroups]
  );

  const handleOnChange = useCallback(
    (option) => {
      dispatch(
        setFilterValue({
          key: SBAT_GROUP_FILTERS.academyTopics,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="Topic Names"
      labelClassName="h5"
    >
      <Select
        value={academyTopics}
        isMulti
        options={academyTopicOptions}
        styles={_styles}
        onChange={handleOnChange}
        placeholder="Select from dropdown"
        className="m-b-xs"
      />
    </Field>
  );
}

export default AcademyTopicFilter;
